import { Alert, Button, Form } from 'antd';
import { CodeInput } from '../../../../../shared/components/CodeInput';
import { DisplayedCodeNotice } from '../../../../../shared/components/DisplayedCodeNotice';

interface EmailOtpCodeFormProps {
  email: string;
  /** Set only on a test deployment that shows codes instead of emailing them. */
  displayedCode: string | null;
  error: string | null;
  submitting: boolean;
  onVerify: (code: string) => void;
  onResend: () => void;
  onCancel: () => void;
}

/** The emailed code comes back here before email codes are turned on, so a dead inbox can't lock the user out. */
export function EmailOtpCodeForm({ email, displayedCode, error, submitting, onVerify, onResend, onCancel }: EmailOtpCodeFormProps) {
  return (
    <section className="rounded-lg border border-line bg-surface p-6">
      <h2 className="text-base font-semibold text-fg">{displayedCode ? 'Enter the code' : 'Check your email'}</h2>
      {displayedCode ? (
        <DisplayedCodeNotice className="mt-4" code={displayedCode} />
      ) : (
        <p className="mt-1.5 text-sm text-muted">
          We sent a 6-digit code to <span className="font-medium text-fg">{email}</span>. It expires in 10 minutes.
        </p>
      )}

      {error && <Alert className="mt-5" type="error" title={error} showIcon />}
      <Form<{ code: string }> className="mt-5" layout="vertical" requiredMark={false} onFinish={(values) => onVerify(values.code)} disabled={submitting}>
        <Form.Item name="code" label="Enter the 6-digit code" rules={[{ required: true, message: 'Enter the 6-digit code' }]}>
          <CodeInput autoFocus onComplete={onVerify} />
        </Form.Item>
        <div className="flex flex-wrap gap-2">
          <Button type="primary" htmlType="submit" loading={submitting}>
            Verify and turn on
          </Button>
          <Button onClick={onCancel} disabled={submitting}>
            Cancel
          </Button>
          <Button type="link" onClick={onResend} disabled={submitting}>
            Send another code
          </Button>
        </div>
      </Form>
    </section>
  );
}
